module.exports = __webpack_public_path__ + "img/icons-arrow-down-dark.fd19403e.svg";